import { createContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useResponsiveCollapse from '../../../helpers/hooks/useResponsiveCollapse';
import { withProviders } from '../../../providers/with-providers';
import { Icon, Text } from '../../foundations';
import { Link } from '../../navigation/link/Link';
import { Box } from '../box';
import { LoadingSpinner } from '../loading-spinner';
import { VoucherContextType, VoucherProps } from './Voucher.model';
import { VoucherForm } from './VoucherForm';
import styles from './Voucher.module.css';
export const VoucherContext = createContext<VoucherContextType>({
	handleClick: async () => {
		return Promise.resolve({ status: false });
	},
	setLoading: () => {},
	value: { status: false }
});

const Component = ({ id, value, handleClick, urlLink }: VoucherProps) => {
	const { t } = useTranslation(['voucher', 'common']);
	const [isCollapsed, setCollapsed] = useResponsiveCollapse({
		overThresholdCollapsed: false,
		underThresholdCollapsed: false
	});
	const [isLoading, setLoading] = useState(false);

	return (
		<VoucherContext.Provider value={{ setLoading, handleClick, value }}>
			<Box id={id} className={styles.box_container}>
				{isLoading && (
					<LoadingSpinner size="big" className={styles.box_loading}>
						{t('common:LOADING_TEXT')}
					</LoadingSpinner>
				)}
				<div className={styles.box_heading}>
					<Text as="h4" font="iberia-headline" size="xs-regular" className={styles.box_title}>
						{t('TITLE')}
					</Text>
					<button
						data-testid="voucher-collapsible"
						className={styles.box_collapsible}
						onClick={() => {
							setCollapsed((prevState) => !prevState);
						}}
					>
						<Icon
							name={isCollapsed ? 'chevron-line-up' : 'chevron-line-down'}
							className={styles.box_icon_collapsable}
							size={isCollapsed ? 16 : 18}
						></Icon>
					</button>
				</div>
				{!isCollapsed && (
					<div className={styles.box_content}>
						<VoucherForm />
						<Link link={urlLink} className={styles.box_link} target="__blank">
							{t('common:TERMS_AND_CONDITIONS_TEXT')}
						</Link>
					</div>
				)}
			</Box>
		</VoucherContext.Provider>
	);
};
Component.displayName = 'Voucher';
export const Voucher = withProviders(Component);
